module.exports = __webpack_public_path__ + "static/crossing-d1ac420646a497bb7c4ae6a7f24000db.png";